<template>
  <table class="table table-hover table-bordered bg-white table-striped">
      <thead>
          <th>#</th>
          <th>Номер ДБЗ</th>
          <th>Предыдущий исполнитель</th>
          <th>Назначенный исполнитель</th>
          <th>Ошибка</th>
      </thead>
      <tbody>
        <template v-if="!load">
          <tr v-for="(excel, index) in excel.import_distribution_debts" :class="{'table-success': excel.status == 'done', 'table-danger': excel.status == 'failed'}">
            <td>{{index+1}}</td>
            <td>
              {{excel.debt_number}}
              <a :href="`/admin/debts?debt_number=${excel.debt_number}`" target="_blank" title="Найти">
                <i class="fa fa-search" aria-hidden="true"></i>
              </a>
            </td>
            <td>{{excel.old_user ? `${excel.old_user.lastname} ${excel.old_user.firstname}`: '' }}</td>
            <td>{{excel.new_user ? `${excel.new_user.lastname} ${excel.new_user.firstname}`: '' }}</td>
            <td>{{excel.errors}}</td>
          </tr>
        </template>
        <tr v-if="load">
          <td colspan="11" class="text-center">
            <loader-wave/>
          </td>
        </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    excel: Object,
    load: Boolean,
  },
}
</script>
